/* eslint-disable  @typescript-eslint/no-explicit-any */
import { IAssetsMetadata, useAssetToolingService } from "../../../services/asset/AssetToolingService";
import { useEffect, useState } from "react";
import { AlertColor } from "@mui/material";
import { Notify } from "../../../components/Notify";
import { LoadingOverlay } from "../../../components/LoadingOverlay";
import * as React from "react";
import { ArtAssetsMetadataTable } from "./ArtAssetsMetadataTable";
import { ArtAssetsMetadataEdit } from "./ArtAssetsMetadataEdit";
import { AppContext } from "../../../utils/AppContext";

const ArtAssetsMetadata = () => {
  const appContext = React.useContext(AppContext);
  const assetToolingService = useAssetToolingService();

  const [loading, setLoading] = useState(true);
  const [alertMessage, setAlertMessage] = useState<string>("");
  const [alertSeverity, setAlertSeverity] = useState<AlertColor>("info");
  const [assetsMetadata, setAssetsMetadata] = useState<any[]>([]);
  const [selectedItem, setSelectedItem] = useState<IAssetsMetadata | undefined>(undefined);
  const [updateMetadataVisible, setUpdateMetadataVisible] = useState<boolean>(false);

  useEffect(() => {
    appContext?.setTitle("View Asset Metadata");
  }, [appContext]);

  useEffect(() => {
    (async () => fetchMetadata())();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchMetadata = async () => {
    try {
      setLoading(true);
      const { list } = await assetToolingService.getMetadata();
      setAssetsMetadata(list);
    } catch (e: any) {
      setAlertMessage(e.debugMessage || "Failed to get assets metadata.");
      setAlertSeverity("error");
    } finally {
      setLoading(false);
    }
  };

  const onUpdateMetadataClick = async (data: IAssetsMetadata) => {
    try {
      setLoading(true);
      await assetToolingService.editMetadata(data.Subcategory, data.Model, data.lastTexture);
      await fetchMetadata();
      setUpdateMetadataVisible(false);
    } catch (e: any) {
      setAlertMessage(e.debugMessage || "Failed to update asset metadata.");
      setAlertSeverity("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ArtAssetsMetadataTable
        rows={assetsMetadata}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        onUpdateMetadataClick={() => setUpdateMetadataVisible(true)}
      />
      <ArtAssetsMetadataEdit
        visible={updateMetadataVisible}
        initialData={selectedItem}
        onAccept={onUpdateMetadataClick}
        onDismiss={() => setUpdateMetadataVisible(false)}
      />
      {alertMessage && <Notify severity={alertSeverity} message={alertMessage} />}
      {loading && <LoadingOverlay />}
    </>
  );
};

export default ArtAssetsMetadata;
